import { Form } from "antd";
import { FC, ComponentType } from "react";
import { Dayjs } from "dayjs";
import TripDateSelect from "../TripDateSelect/TripDateSelect";

type DateSelectContentProps = {
  name: string;
  rules: any[];
  dependencies?: string[];
  label: string;
  icon?: ComponentType<{ className?: string }>;
  disabledDate?: (date: Dayjs) => boolean;
  className?: string;
  closeSheet?: () => void;
};

const DateSelectContent: FC<DateSelectContentProps> = ({ name, rules, dependencies, label, icon, disabledDate, className, closeSheet }) => {
  return (
    <Form.Item
      name={name}
      dependencies={dependencies}
      className="m-0! border-none! focus:outline-none! focus-within:ring-0! w-full font-semibold md:flex-1 [&_.ant-form-item-explain-error]:hidden [&_.ant-form-item-explain-error]:md:block [&_.ant-form-item-explain-error]:md:px-4!"
      rules={rules}
    >
      <TripDateSelect label={label} icon={icon} disabledDate={disabledDate} className={className} closeSheet={closeSheet} />
    </Form.Item>
  );
};

export default DateSelectContent;
